export const DEFAULT_MIN_DATE = '1900-01-01 00:00:00'

export const MONTH_UNIT = 12
export const HOUR_UNIT = 24
export const MINUTE_UNIT = 60
